import React from 'react';
import { Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';

const buildLabel = (action) => {
  if (action?.params?.label) return action.params.label;
  if (action.type === 'export_csv') return 'Export CSV';
  if (action.type === 'refresh') return 'Refresh';
  if (action.type === 'clear_filters') return 'Clear filters';
  if (action.type === 'open_report') return 'Open report';
  if (action.type === 'sync_to_di') return 'Sync to DI';
  return 'Run action';
};

const toTestIdSegment = (value) =>
  String(value || 'action')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'action';

const ReportActionsBar = ({ actions, onAction, loadingActionTypes = [] }) => {
  const loadingSet = new Set(Array.isArray(loadingActionTypes) ? loadingActionTypes : []);

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }} data-testid="report-actions-bar">
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Actions
        </Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} flexWrap="wrap">
          {actions.map((action) => {
            const isLoading = loadingSet.has(action.type);
            return (
              <Button
                key={`${action.type}-${action.params?.label || action.params?.modalId || action.params?.reportId || 'action'}`}
                data-testid={`report-action-${toTestIdSegment(action.type)}-${toTestIdSegment(action.params?.label || action.params?.modalId || action.params?.reportId)}`}
                variant={action.source === 'default' ? 'outlined' : 'contained'}
                onClick={() => onAction(action)}
                disabled={Boolean(action.disabled)}
                startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
                sx={{ textTransform: 'none' }}
              >
                {action.type === 'refresh' && isLoading ? 'Refreshing...' : buildLabel(action)}
              </Button>
            );
          })}
          {actions.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No actions configured for this report.
            </Typography>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ReportActionsBar;
